exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "ng-select {\n  min-width: 80px; }\n", ""]);

// exports
